'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isInvisible = function isInvisible(v) {
  return v === undefined || v === '' || v === null;
};

exports.default = isInvisible;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/isInvisible.js
// module id = 1071
// module chunks = 0